import React, { useEffect, useRef, useState } from "react"

import { Spinner } from "components"
import { getFoods } from "services"
import LsSearch from "./StrmrmfsSearch"
import StrmrmfsFoodCard from "./StrmrmfsFoodCard"
import classes from "./StrmrmfsFoods.module.scss"
import { refactorFoods } from "utils"

const limit = 20

const initialFilterState = {
  search: ""
}

const StrmrmfsFoods = props => {
  const {
    selectedFoodOptions,
    setSelectedFoodOptions,
    selectedCategory,
    sourceBranchId
  } = props

  const [foods, setFoods] = useState(null)
  const [filter, setFilter] = useState(initialFilterState)

  const unmount = useRef(false)

  const getAllFoods = async () => {
    if (foods !== null) {
      setFoods(null)
    }

    const categoryIds =
      selectedCategory ? [selectedCategory] : []

    try {
      const response =
        await getFoods({
          skip: 0,
          limit,
          isAvailable: true,
          branchId: sourceBranchId,
          categoryIds,
          ...filter
        })

      if (unmount.current) return


      const refactoredFoods =
        refactorFoods(
          response,
          sourceBranchId
        )

      setFoods(refactoredFoods)
    } catch (err) {
      console.log(err)
    }
  }

  useEffect(() => {
    getAllFoods()
  }, [
    filter,
    selectedCategory,
    sourceBranchId
  ])

  useEffect(() => {
    unmount.current = false

    return () => { unmount.current = true }
  }, [])

  return (
    <div className={classes["container"]}>
      <LsSearch
        delay={1200}
        placeholder="جست و جوی کالا..."
        onSearch={(search) =>
          setFilter(prev => ({ ...prev, search }))
        }
      />

      {foods !== null
        ?
        <div className={classes["list"]}>
          {foods.map(food =>
            <div
              key={food._id}
              className={classes["card"]}
            >
              <StrmrmfsFoodCard
                food={food}
                sourceBranchId={sourceBranchId}
                selectedFoodOptions={selectedFoodOptions}
                setSelectedFoodOptions={setSelectedFoodOptions}
              />
            </div>
          )}
        </div>
        :
        <div className={classes["loading"]}>
          <Spinner color="var(--color-primary)" />
        </div>
      }
    </div>
  )
}

export default StrmrmfsFoods